import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useGetTutorial } from "../../../hooks/Tutorial/useGetTutorial"
import { TutorialEntity } from "../../../Objects/Tutorial/TutorialEntity"
import { AdminTutorialPopup } from "./AdminTutorialPopup"
import { ETutorialAudienceType } from "../../../Enum/ETutorialAudienceType"

const audienceLabelMap: Record<ETutorialAudienceType, string> = {
  [ETutorialAudienceType.Restaurant]: "Restaurante",
  [ETutorialAudienceType.Courier]: "Entregador",
  [ETutorialAudienceType.Both]: "Ambos",
}

const getAudienceLabel = (audience: TutorialEntity["audience"]) => {
  if (audience in audienceLabelMap) {
    return audienceLabelMap[audience as ETutorialAudienceType]
  }

  if (typeof audience === "string") {
    const normalized = audience.toLowerCase()

    if (normalized === "restaurant") return audienceLabelMap[ETutorialAudienceType.Restaurant]
    
    if (normalized === "courier") return audienceLabelMap[ETutorialAudienceType.Courier]
   
    if (normalized === "both") return audienceLabelMap[ETutorialAudienceType.Both]
  }

  return ""
}

export const AdminTutorialSection: React.FC = () => {
  const { handleGetTutorialAdmin } = useGetTutorial()

  const [tutorials, setTutorials] = useState<TutorialEntity[]>([])

  const [isOpen, setIsOpen] = useState(false)

  const [editing, setEditing] = useState<TutorialEntity | undefined>(undefined)

  const refresh = () => handleGetTutorialAdmin((data) => setTutorials(data))

  const categories = Array.from(new Set(tutorials.map((item) => item.category.trim()).filter((item) => item.length > 0)))

  useEffect(() => {
    refresh()
  }, [])

  return (
    <>
      <div className="p-2">
        <List
          messageCount="Tutoriais"
          messageEmpty="Nenhum tutorial cadastrado"
          nameFindSearch="Buscar tutorial"
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          data={tutorials.map((item, index) => ({
            id: item.id,
            index,
            title: item.title,
            linkImage: "",
            isDisable: item.status !== EEnableStatusType.Active,
            dataFilter: [item.title, item.category, getAudienceLabel(item.audience)].filter((value) => value.length > 0),
            children: (
              <div className="p-3">
                <p className="text-xs font-black text-orange-600 uppercase">{item.category}</p>

                <p className="text-sm font-semibold text-slate-900">{item.title}</p>

                <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-slate-500">{getAudienceLabel(item.audience)}</p>

                <p className="text-xs text-slate-500 truncate">{item.youtubeUrl}</p>
              </div>
            ),
          }))}
          handleAddButton={() => {
            setEditing(undefined)
            setIsOpen(true)
          }}
          handleRefreshButton={refresh}
          handleOnClick={(id) => {
            setEditing(tutorials.find((item) => item.id === id))
            setIsOpen(true)
          }}
        />
      </div>

      {isOpen && (
        <AdminTutorialPopup
          tutorial={editing}
          categories={categories}
          onClose={() => setIsOpen(false)}
          onSuccess={refresh}
        />
      )}
    </>
  )
}
